import React from 'react';
import { Input } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { DrupiPrimaryActionButton } from '../../UI/buttons/primary-button-action';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';

const { TextArea } = Input;

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
  loading?: boolean;
}

export const ChatInput: React.FC<ChatInputProps> = ({ onSendMessage, disabled = false, loading = false }) => {
  const { fontSize, spacing, screens } = useResponsiveSizes();
  const [message, setMessage] = React.useState('');

  const handleSend = () => {
    const trimmed = message.trim();
    if (trimmed && !disabled) {
      onSendMessage(trimmed);
      setMessage('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const textAreaRows = screens.xs ? 1 : screens.sm ? 2 : 2;

  return (
    <div
      style={{
        padding: `0 ${spacing.sm}px`,
        display: 'flex',
        gap: spacing.sm,
        alignItems: 'flex-start'
      }}
    >
      <TextArea
        value={message}
        onChange={e => setMessage(e.target.value)}
        onKeyDown={handleKeyPress}
        placeholder={'Escribe tu mensaje...'}
        disabled={disabled}
        autoSize={false}
        rows={textAreaRows}
        style={{
          flex: 1,
          resize: 'none',
          borderRadius: 8,
          backgroundColor: 'white',
          borderColor: '#9d9d9d86',
          fontSize: fontSize.base
        }}
      />
      <DrupiPrimaryActionButton
        label={screens.xs ? '' : 'Enviar'}
        icon={<SendOutlined />}
        onClick={handleSend}
        disabled={disabled || !message.trim()}
        loading={loading}
      />
    </div>
  );
};
